export default "__VITE_ASSET__840d63d4__"